import { Component } from '@angular/core';

@Component({
  selector: 'app-new-company',
  // imports: [],
  templateUrl: './new-company.component.html',
  styleUrl: './new-company.component.scss',
  standalone: false
})
export class NewCompanyComponent {

}
